﻿let IsPlaying: boolean = false;
let analyser: AnalyserNode;
let audioContext: any;
let source: any;
let audioPlayer: HTMLAudioElement;

function InitRecorder(mediaRecorder: MediaRecorder) {
    if (audioContext == null) {
        audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();

        analyser = audioContext.createAnalyser();
        analyser.fftSize = 2048;
        console.log(audioContext.state);
        if (audioContext.state === 'suspended') {
            audioContext.resume();
        }

        const bufferLength = analyser.fftSize;
        console.log("Buffer length: " + bufferLength);
        const dataArray = new Uint8Array(bufferLength);

        function AudioUpdate() {
            if (!IsPlaying) {
                //console.log("Bar height: none set");

                document.getElementById('h1')!.style.height = '5%';
                document.getElementById('h2')!.style.height = '5%';
                document.getElementById('h3')!.style.height = '5%';
                document.getElementById('h4')!.style.height = '5%';
                document.getElementById('h5')!.style.height = '5%';

                setTimeout(AudioUpdate, 100);
                return;
            }

            if (audioContext.state === 'suspended') {
                audioContext.resume();
            }

            analyser.getByteTimeDomainData(dataArray);
            //console.log(dataArray);
            let sumSq = 0;
            for (let i = 0; i < dataArray.length; i++) {
                let a = (dataArray[i] - 128.0) / 128.0;
                sumSq += a * a;
            }
            let rms = Math.sqrt(sumSq / dataArray.length);
            const norm = Math.min(1, rms / 0.70710678);
            const bar = Math.min(100, Math.round(norm * 500));
            document.getElementById('h1')!.style.height = 0.3 * bar * Math.random() + '%';
            document.getElementById('h2')!.style.height = 0.8 * bar * Math.random() + '%';
            document.getElementById('h3')!.style.height = bar * Math.random() + '%';
            document.getElementById('h4')!.style.height = 0.8 * bar * Math.random() + '%';
            document.getElementById('h5')!.style.height = 0.3 * bar * Math.random() + '%';

            setTimeout(AudioUpdate, 100);
        };
        AudioUpdate();
    }

    mediaRecorder.addEventListener('pause', () => { IsPlaying = false; });
    mediaRecorder.addEventListener('stop', () => { IsPlaying = false; });

    mediaRecorder.addEventListener('resume', () => { IsPlaying = true; });
    mediaRecorder.addEventListener('start', () => { IsPlaying = true; });

    ConnectStream(mediaRecorder.stream);
}

function Init() {
    if (audioContext != null) return;

    audioPlayer = document.getElementById("openAiSpeach") as HTMLAudioElement;

    audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();

    analyser = audioContext.createAnalyser();
    analyser.fftSize = 2048;
    console.log(audioContext.state);
    if (audioContext.state === 'suspended') {
        audioContext.resume();
    }

    const bufferLength = analyser.fftSize;
    console.log("Buffer length: " + bufferLength);
    const dataArray = new Uint8Array(bufferLength);

    function AudioUpdate() {
        if (!IsPlaying) {
            //console.log("Bar height: none set");

            document.getElementById('h1')!.style.height = '5%';
            document.getElementById('h2')!.style.height = '5%';
            document.getElementById('h3')!.style.height = '5%';
            document.getElementById('h4')!.style.height = '5%';
            document.getElementById('h5')!.style.height = '5%';

            setTimeout(AudioUpdate, 100);
            return;
        }

        if (audioContext.state === 'suspended') {
            audioContext.resume();
        }

        analyser.getByteTimeDomainData(dataArray);
        //console.log(dataArray);
        let sumSq = 0;
        for (let i = 0; i < dataArray.length; i++) {
            let a = (dataArray[i] - 128.0) / 128.0;
            sumSq += a * a;
        }
        let rms = Math.sqrt(sumSq / dataArray.length);
        const norm = Math.min(1, rms / 0.70710678);
        const bar = Math.min(100, Math.round(norm * 500));
        document.getElementById('h1')!.style.height = 0.3 * bar * Math.random() + '%';
        document.getElementById('h2')!.style.height = 0.8 * bar * Math.random() + '%';
        document.getElementById('h3')!.style.height = bar * Math.random() + '%';
        document.getElementById('h4')!.style.height = 0.8 * bar * Math.random() + '%';
        document.getElementById('h5')!.style.height = 0.3 * bar * Math.random() + '%';

        setTimeout(AudioUpdate, 100);
    };

    AudioUpdate();

    audioPlayer.addEventListener('pause', () => { IsPlaying = false; });
    audioPlayer.addEventListener('ended', () => { IsPlaying = false; });

    audioPlayer.addEventListener('play', () => { IsPlaying = true; });
    audioPlayer.addEventListener('playing', () => { IsPlaying = true; });

    audioPlayer.addEventListener("loadedmetadata", () => {
        ConnectStream(audioPlayer.srcObject as MediaStream | null);
    });

    ConnectStream(audioPlayer.srcObject as MediaStream | null);
}

function ConnectStream(s: MediaStream | null) {
    if (!s || s.getAudioTracks().length === 0) return;
    try { source?.disconnect(); } catch { }
    source = audioContext.createMediaStreamSource(s);
    source.connect(analyser);
};

export const VoiceIndicator = {
    Init,
    InitRecorder
}